import { Col, Pagination, Row, Empty, Spin, Breadcrumb } from 'antd';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDevice } from '../hooks/useDevice';
import Footer from '../component/Footer';
import { HomeOutlined, ArrowRightOutlined, PictureOutlined, AppstoreOutlined, AlignLeftOutlined } from '@ant-design/icons';
import logo from '../component/image/logo.png';
import LearningGoal from '../component/LearningGoal';

export default function Topic() {
    const { isMobile } = useDevice();
    const [dataTopic, setdataTopic] = useState({});
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({ page: 1, pageSize: 12 });
    const [displayOpts, setDisplayOpts] = useState({
        showImage:       true,
        showCourseCount: true,
        showDescription: true,
    });

    const toggle = (key) => setDisplayOpts(prev => ({ ...prev, [key]: !prev[key] }));

    const topic = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/topic/getAll`, { params: pagination });
            setdataTopic(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        topic();
    }, [pagination]);

    const colors = [
        { bg: 'bg-blue-500', light: 'bg-blue-50', text: 'text-blue-600', gradient: 'from-blue-500 to-blue-700' },
        { bg: 'bg-green-500', light: 'bg-green-50', text: 'text-green-600', gradient: 'from-green-500 to-emerald-700' },
        { bg: 'bg-purple-500', light: 'bg-purple-50', text: 'text-purple-600', gradient: 'from-purple-500 to-purple-700' },
        { bg: 'bg-orange-500', light: 'bg-orange-50', text: 'text-orange-600', gradient: 'from-orange-500 to-red-600' },
        { bg: 'bg-pink-500', light: 'bg-pink-50', text: 'text-pink-600', gradient: 'from-pink-500 to-rose-700' },
        { bg: 'bg-cyan-500', light: 'bg-cyan-50', text: 'text-cyan-600', gradient: 'from-cyan-500 to-teal-700' },
    ];

    return (
        <>
            <div className="min-h-screen bg-[#0a1628]">
                {/* Hero */}
                <div className="bg-gradient-to-r from-[#0f1e35] to-[#1a2d4a] text-white py-16 relative overflow-hidden border-b border-white/10">
                    <div className="absolute top-0 right-0 w-80 h-80 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/3"></div>
                    <div className="absolute bottom-0 left-10 w-48 h-48 bg-white/5 rounded-full translate-y-1/3"></div>
                    <div className="max-w-screen-xl mx-auto px-6 relative z-10">
                        <Breadcrumb
                            className="mb-6 [&_.ant-breadcrumb-link]:text-blue-300 [&_.ant-breadcrumb-separator]:text-blue-400 [&_a]:text-blue-300 [&_a:hover]:text-white"
                            items={[
                                { title: <Link to="/"><HomeOutlined /> Trang chủ</Link> },
                                { title: <span className="text-white font-medium">Tất cả chủ đề</span> },
                            ]}
                        />
                        <h1 className="text-4xl md:text-5xl font-extrabold mb-3">Tất Cả Chương Trình Học</h1>
                        <p className="text-lg text-blue-300 max-w-2xl">Khám phá các chủ đề học tiếng Anh được thiết kế riêng cho phương pháp Effortless English</p>
                    </div>
                </div>

                <div className="max-w-screen-xl mx-auto px-6 py-10">
                    {/* Learning Goal */}
                    <LearningGoal />

                    {/* Display Settings Bar */}
                    <div className="mb-8 bg-[#0f1e35] border border-white/10 rounded-2xl px-6 py-4">
                        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">Tuỳ chỉnh hiển thị</p>
                        <div className="flex flex-wrap gap-3">
                            {[
                                { key: 'showImage',       icon: <PictureOutlined />,    label: 'Ảnh bìa' },
                                { key: 'showCourseCount', icon: <AppstoreOutlined />,   label: 'Số khóa học' },
                                { key: 'showDescription', icon: <AlignLeftOutlined />,  label: 'Mô tả' },
                            ].map(({ key, icon, label }) => (
                                <button
                                    key={key}
                                    onClick={() => toggle(key)}
                                    className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium border transition-all ${
                                        displayOpts[key]
                                            ? 'bg-blue-500 text-white border-blue-500 shadow-md shadow-blue-500/20'
                                            : 'bg-white/5 text-gray-400 border-white/10 hover:border-blue-400 hover:text-blue-400'
                                    }`}
                                >
                                    {icon}
                                    {label}
                                    {displayOpts[key] && (
                                        <span className="w-2 h-2 rounded-full bg-white/70 ml-0.5"></span>
                                    )}
                                </button>
                            ))}
                        </div>
                    </div>

                    {loading ? (
                        <div className="flex justify-center py-20"><Spin size="large" /></div>
                    ) : !dataTopic?.data || dataTopic.data.length === 0 ? (
                        <div className="py-20"><Empty description={<span className="text-gray-400">Chưa có chủ đề nào</span>} /></div>
                    ) : (
                        <>
                            <Row gutter={[24, 24]}>
                                {dataTopic?.data?.map((topic, index) => {
                                    const color = colors[index % colors.length];
                                    return (
                                        <Col xs={24} sm={12} md={8} lg={6} key={index}>
                                            <Link to={'/course/' + topic.slug} className="block group h-full">
                                                <div className="bg-[#0f1e35] border border-white/10 rounded-xl hover:border-white/20 transition-all duration-300 overflow-hidden h-full flex flex-col group-hover:-translate-y-1">
                                                    {/* Image */}
                                                    {displayOpts.showImage && (
                                                        <div className="h-44 overflow-hidden relative">
                                                            <img
                                                                src={topic.image_url || logo}
                                                                alt={topic.title}
                                                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                                                crossOrigin="anonymous"
                                                                onError={(e) => { e.target.onerror = null; e.target.src = logo; }}
                                                            />
                                                            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                                                            {displayOpts.showCourseCount && (
                                                                <div className="absolute bottom-3 left-3">
                                                                    <span className={`${color.bg} text-white text-xs font-bold px-3 py-1 rounded-full shadow`}>
                                                                        {topic.totalCourses || 0} khóa học
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}

                                                    {/* Content */}
                                                    <div className="p-5 flex flex-col flex-1">
                                                        <h3 className="text-lg font-bold text-white line-clamp-2 group-hover:text-blue-400 transition-colors mb-2">
                                                            {topic.title}
                                                        </h3>
                                                        {!displayOpts.showImage && displayOpts.showCourseCount && (
                                                            <span className={`inline-block mb-2 ${color.bg} text-white text-xs font-bold px-3 py-1 rounded-full w-fit`}>
                                                                {topic.totalCourses || 0} khóa học
                                                            </span>
                                                        )}
                                                        {displayOpts.showDescription && topic.description && (
                                                            <p className="text-gray-400 text-sm line-clamp-2 mb-3">{topic.description}</p>
                                                        )}
                                                        <div className="mt-auto flex items-center justify-between pt-3 border-t border-white/10">
                                                            <span className="text-sm text-gray-500">Xem chi tiết</span>
                                                            <span className="text-blue-400 group-hover:translate-x-1 transition-transform">
                                                                <ArrowRightOutlined />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </Col>
                                    );
                                })}
                            </Row>

                            {dataTopic?.total > pagination.pageSize && (
                                <div className="flex justify-center mt-12">
                                    <Pagination
                                        current={pagination.page}
                                        total={dataTopic?.total}
                                        pageSize={pagination.pageSize}
                                        showSizeChanger={false}
                                        onChange={(p, ps) => setPagination({ page: p, pageSize: ps })}
                                    />
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
};
